import { useMatchRoute } from '@tanstack/react-router';
import { useSessionStore } from '@/entities/session/model/sessionStore';
import { MainRouteLayout } from '@/widgets/route-layout/ui/main/MainRouteLayout';
import { SimpleRouteLayout } from '@/widgets/route-layout/ui/SimpleRouteLayout';

export const RootComponent = () => {
  const matchRoute = useMatchRoute();
  const isAuthenticated = useSessionStore((s) => s.isAuthenticated);
  const isLoginPage = !!matchRoute({ to: '/login' });
  const isChangePasswordPage = !!matchRoute({ to: '/change-password' });
  const isPasswordResetPage = !!matchRoute({ to: '/password-reset' });
  const isAnalysisPage = !!matchRoute({
    to: '/settlement-statistics-converter/$resultId/analysis',
  });

  if (
    !isAuthenticated ||
    isLoginPage ||
    isChangePasswordPage ||
    isPasswordResetPage ||
    isAnalysisPage
  ) {
    return <SimpleRouteLayout />;
  }

  return <MainRouteLayout />;
};
